import { apiClient, type ApiClientResponse, routes } from 'common/services';

export const getInvToken = async ({ communityId }: { communityId: string }) =>
  apiClient.post<{ token: string }, ApiClientResponse<{ token: string }>>(routes.community.invToken(communityId));
